var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import tickImage from "@irati/ui/images/tick-green-circle.png";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { perksGOTracking } from "@irati-tracking/perksgo";
import Flex from "@irati/ui/src/Flex";
import { Body, H3 } from "@irati/ui/src/Typography";
import Link, { ButtonLink, ButtonRouterLink } from "@irati/ui/src/Link";
import { TickImage, PerksGOImage } from "./styled";
var HasCardBlock = /** @class */ (function (_super) {
    __extends(HasCardBlock, _super);
    function HasCardBlock() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HasCardBlock.prototype.render = function () {
        var apps = this.context.apps;
        var _a = this.props, formatMessage = _a.formatMessage, isPerksGoRetailDeal = _a.isPerksGoRetailDeal, dealExternalLinks = _a.dealExternalLinks;
        return (React.createElement(Flex, { direction: "column", alignItems: "center" },
            React.createElement(H3, { marginBottom: 1 },
                React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.title" })),
            React.createElement(Flex, null,
                React.createElement(TickImage, { src: tickImage, alt: formatMessage({ id: "perksgo.perksGoImportantInfo.greenTickAlt" }) }),
                React.createElement(Body, { small: true, marginBottom: "0" },
                    React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.title" }))),
            React.createElement(PerksGOImage, { icon: "perksGO", size: 80 }),
            React.createElement(Body, { small: true, textAlign: "center", margin: "0 auto", maxWidth: "280px" },
                React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.text" })),
            !isPerksGoRetailDeal && (React.createElement(React.Fragment, null,
                React.createElement(ButtonRouterLink, { full: true, app: apps.WALLET, to: "/", onClick: perksGOTracking.goToWalletCTA, marginTop: 2 },
                    React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.walletButton" })),
                React.createElement(ButtonRouterLink, { full: true, app: apps.ACCOUNT, to: "/settings/linkedcards", onClick: perksGOTracking.manageLinkedCardsCTA, marginTop: 2 },
                    React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.linkedCardsButton" })))),
            isPerksGoRetailDeal && (React.createElement(React.Fragment, null,
                React.createElement(ButtonLink, { primary: true, full: true, href: dealExternalLinks === null || dealExternalLinks === void 0 ? void 0 : dealExternalLinks.web, target: "_blank", margin: [3, 0, 2] },
                    React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.visitOnlineStore" })),
                React.createElement(Link, { href: formatMessage({ id: "perksgo.perksGoImportantInfo.hasCardBlock.refundPolicyLink" }), target: "_blank" },
                    React.createElement(FormattedMessage, { id: "perksgo.perksGoImportantInfo.hasCardBlock.refundPolicy" }))))));
    };
    HasCardBlock.contextTypes = {
        apps: PropTypes.object.isRequired
    };
    return HasCardBlock;
}(PureComponent));
export default injectIntl(HasCardBlock);
